module.exports = __webpack_public_path__ + "img/LOGOSGPF256Prancheta 4.78ae8a95.png";